import React from 'react';
import ProductImageSlider from './ProductImageSlider';
import { useTranslation } from 'react-i18next';
import { LogoMediumOutlinedIcon, NoPhotoIcon, NotSupportedIcon } from '../Icons';
import SkeletonLoader from '../ui/SkeletonLoader';

export const ProductImageBlock = ({
  status,
  images,
  mainImage,
  className = '',
  sliderClassName = '',
  slideMaxCount,
  isLoadingProduct,
}) => {
  const { t } = useTranslation();
  const isExtracting = status === 'EXTRACTING';
  const isFailed = status === 'FAILED';
  const isExtracted = status === 'EXTRACTED';
  const notPhoto = !isExtracting && !isFailed && !mainImage;
  const showLoadingState = isExtracting || isLoadingProduct;

  return (
    <>
      {(!isExtracted || notPhoto) && (
        <div className={`align-items-center d-flex flex-fill h-100 image-area justify-content-center ${className}`}>
          {showLoadingState && (
            <BlockInfo
              hasAnimation={true}
              descClassName='text-black-50'
              className='no-photo justify-content-center'
              icon={<LogoMediumOutlinedIcon width='54' height='54' />}
              description={isLoadingProduct ? t('text_loading') : t('text_extracting')}
            />
          )}
          {isFailed && (
            <BlockInfo
              descClassName='text-black-50'
              className='no-photo justify-content-center'
              icon={<NotSupportedIcon />}
              description={t('text_not_supported')}
            />
          )}
          {notPhoto && (
            <BlockInfo
              descClassName='text-black-50'
              className='no-photo justify-content-center'
              icon={<NoPhotoIcon />}
              description={t('text_no_photo')}
            />
          )}
        </div>
      )}
      {isExtracted &&
        !notPhoto &&
        (images?.length ? (
          <ProductImageSlider
            mainImage={mainImage}
            slideMaxCount={slideMaxCount}
            className={sliderClassName}
            images={images}
          />
        ) : (
          <img src={mainImage} alt='rimg' />
        ))}
    </>
  );
};

export const BlockInfo = ({ className = '', hasAnimation, icon, description, descClassName = 'text-white' }) => {
  return (
    <div className={`image-block-info d-flex flex-column align-items-center ${className}`}>
      {icon}
      <p className={`mb-0 mt-5 ${descClassName}`}>{description}</p>
      {hasAnimation && <SkeletonLoader type='basic' count={3} />}
    </div>
  );
};
